import { render } from "./ExampleNavBar.vue?vue&type=template&id=353fad66"
import script from "./ExampleNavBar.vue?vue&type=script&lang=ts"
export * from "./ExampleNavBar.vue?vue&type=script&lang=ts"
script.render = render

export default script